var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('datepicker',{attrs:{"value":_vm.value,"inline":true,"disabled-dates":_vm.getDisabledDays(),"language":_vm.locale,"openDate":_vm.openDate,"monday-first":true},on:{"selected":_vm.onselect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }